import { ChangePasswordButton } from './change-password-button.component'
import { TwoFAButton } from './two-fa-button.component'
import { ExposePrivateKeyButton } from 'src/components/expose-private-key-modal/expose-private-key-button.component'

import { useStyles } from '../styles'
import { useGetUserPrivateKey, useVerifyUserPrivateKeyExpose } from 'src/hooks'
import { ETranslationNs, IUserWalletBase, PrivateKeyRequestFn, PrivateKeyVerifyFn } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { LoginProvidersButton } from './login-providers'

interface IProps {
  wallet: Omit<IUserWalletBase, 'privateKey'> | undefined
}

const SettingsSecurity = ({ wallet }: IProps) => {
  const classes = useStyles()

  return (
    <>
      <div className={`${classes.itemBorder} ${classes.settingsItemWrapper}`}>
        <h4 className={classes.itemSubtitle}>
          <HelperWrapper t="user-profile-security-title" ns={ETranslationNs.UserProfile} />
        </h4>
        <div className={classes.settingsItems}>
          <div className={classes.settingsItem}>
            <ChangePasswordButton />
          </div>
          <div className={classes.settingsItem}>
            <TwoFAButton />
          </div>
          <div className={classes.settingsItem}>
            <ExposePrivateKeyButton
              verifyFn={useVerifyUserPrivateKeyExpose as PrivateKeyVerifyFn}
              requestFn={useGetUserPrivateKey as PrivateKeyRequestFn}
              disabled={wallet && !wallet.is_custodial}
            />
          </div>
          <div className={classes.settingsItem}>
            <LoginProvidersButton />
          </div>
        </div>
      </div>
    </>
  )
}

export { SettingsSecurity }
